export const css = `
:root {
	--chat--color--primary: #e74266;
	--chat--color--primary-shade-50: #db4061;
	--chat--color--primary--shade-100: #cf3c5c;
	--chat--color--secondary: #20b69e;
	--chat--color-secondary-shade-50: #1ca08a;
	--chat--color-white: #ffffff;
	--chat--color-light: #f2f4f8;
	--chat--color-light-shade-50: #e6e9f1;
	--chat--color-light-shade-100: #c2c5cc;
	--chat--color-medium: #d2d4d9;
	--chat--color-dark: #101330;
	--chat--color-disabled: #777980;
	--chat--color-typing: #404040;

	--chat--spacing: 0.5rem;
	--chat--border-radius: 0.25rem;
	--chat--transition-duration: 0.15s;

	--chat--window--width: 100%;
	--chat--window--height: 750px;

	--chat--header-height: auto;
	--chat--header--padding: var(--chat--spacing);
	--chat--header--background: white;
	--chat--header--color: var(--chat--color-light);
	--chat--header--border-top: none;
	--chat--header--border-bottom: none;
	--chat--header--border-bottom: none;
	--chat--header--border-bottom: none;
	--chat--heading--font-size: 1em;
	--chat--header--color: rgb(51, 51, 51);
	--chat--subtitle--font-size: 0.5 em;
	--chat--subtitle--line-height: 1.5;

	--chat--textarea--height: 100px;

	--chat--message--font-size: 0.9rem;
	--chat--message--padding: var(--chat--spacing);
	--chat--message--border-radius: var(--chat--border-radius);
	--chat--message-line-height: 1.8;
	--chat--message--bot--background: var(--chat--color-white);
	--chat--message--bot--color: var(--chat--color-dark);
	--chat--message--bot--border: solid var(--sl-input-border-width) var(--sl-input-border-color);
	--chat--message--user--background: var(--chat--color--secondary);
	--chat--message--user--color: var(--chat--color-white);
	--chat--message--user--border: none;
	--chat--message--pre--background: rgba(0, 0, 0, 0.05);

	--chat--toggle--background: var(--chat--color--primary);
	--chat--toggle--hover--background: var(--chat--color--primary-shade-50);
	--chat--toggle--active--background: var(--chat--color--primary--shade-100);
	--chat--toggle--color: var(--chat--color-white);
	--chat--toggle--size: 64px;
	--chat--toggle--width: 80px;
	--chat--toggle--height: 80px;


	--chat--input--border: solid var(--sl-input-border-width) var(--sl-input-border-color);
	--chat--input--border-radius: var(--sl-input-border-radius-medium);

  .chat-layout .chat-header {
    gap: 0px;
	align-items: center;

	h1 {
		font-size: 28px;
	}
  }

  .chat-layout .chat-body {
	background: white;
	min-height: 28px;
  }

  .chat-message.chat-message-from-bot:not(.chat-message-transparent) {
	border: none;
  }

  .chat-window-wrapper .chat-window .chat-layout {
	border: 1px solid darkgray;
	border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  .chat-message.chat-message-from-bot:first-of-type {
	font-weight: 800;
  }

  .chat-message-markdown {
	text-align: start;
  }

  .chat-message chat-message-from-user {
	background-color: rgba(173, 216, 249, 0.7);
  }

  .chat-message.chat-message-from-user:not(.chat-message-transparent) {
	background-color: rgba(173, 216, 249, 0.7);
	color: var(--chat--header--color);
  }


  .chat-window-wrapper .chat-window-toggle {
	background: transparent;
  }

  .chat-window-wrapper .chat-window-toggle:hover {
	background: transparent;
  }

  .chat-window-wrapper .chat-window  {
	border-radius: 12px;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 2px 8px;
  }

  .chat-window-toggle {
	> :first-child {
		visibility: hidden;
	}
  }

  .chat-input-send-button {
	width: 40px;
  }

`;
